const React = require("react");

function ChevronDoubleRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 5l7 7-7 7M5 5l7 7-7 7"
  }));
}

module.exports = ChevronDoubleRightIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ChevronDoubleRightIcon.js
 ** module id = 473
 ** module chunks = 0
 **/